export enum MainStatusEnum {
    Empty = -1,
    Owner = 0,
    Deal = 1,
}